enum ModalPrompt {
    Description,
    Images,
    Details,
}

const modalTitle = (currentModalPrompt: ModalPrompt): string => {
    switch (currentModalPrompt) {
        case ModalPrompt.Description:
            return "Description";
        case ModalPrompt.Details:
            return "Details";
        case ModalPrompt.Images:
            return "Images";
    }
}

export default ModalPrompt;
export { modalTitle };